module.exports = __webpack_public_path__ + "media/images/my_apps/feature_icons/icon_gross_and_micro_blue-06b5ea8763c5d283b1269171ea7d6645.svg";